import { Controller } from "@hotwired/stimulus"

// A post shown in translation keeps the original with it, out of sight; the
// line beneath turns one over for the other (PiecesHelper#rendition).
//
//   data-rendition-original-value     the word on the switch while the translation shows
//   data-rendition-translation-value  the word on it while the original shows
export default class extends Controller {
  static targets = ["translation", "original", "switch"]
  static values = { original: String, translation: String }

  toggle(event) {
    event?.preventDefault()
    const showingOriginal = !this.originalTarget.hidden
    this.originalTarget.hidden = showingOriginal
    this.translationTarget.hidden = !showingOriginal
    this.switchTarget.textContent = showingOriginal ? this.originalValue : this.translationValue
  }
}
